import React from "react";
// import { IconXiajiantou } from "../../components/IconXiajiantou";
// import { Icon28Fanhui } from "../../icons/Icon28Fanhui";
import "./style.css";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { useEffect } from 'react';
import { useInfoMutation, useUpdateMutation, useTimesMutation } from '../../store/pageApi2';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { changeXuan } from "../../store/pageSlice";
import Sign from '../qianming'

const Information = () => {

  // 2026 大会取消工厂参观。整块 UI、选场次弹窗、必填校验都按这个开关走，
  // 改回 true 即可恢复（后端 f1 字段和 /times 接口都还在，没动）。
  const SHOW_FACTORY = false

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [gccg12, setgccg12] = useState(t("f_meet_join"))
  const [gccg12id, setgccg12id] = useState(1)
  const [gccg12gou, setgccg12gou] = useState(-1)
  const [zzwc, setzzwc] = useState(-1)
  const [bjdl, setbjdl] = useState(-1)
  const [dxwy, setdxwy] = useState(-1)
  const [gccg13, setgccg13] = useState(t("f_meet_join"))
  const [yiyue, setyiyue] = useState(false)
  const [gccg13id, setgccg13id] = useState(1)
  const [gccg13gou, setgccg13gou] = useState(-1)
  const [hei, sethei] = useState(false)
  const [hei2, sethei2] = useState(false)
  const [done, setdone] = useState(false)
  const [done2, setdone2] = useState(false)
  const [queren, setqueren] = useState(false)
  const [queren2, setqueren2] = useState(false)
  const [queren3, setqueren3] = useState(false)
  const [chayue, setchayue] = useState(false)
  const [baocuo, setbaocuo] = useState(false)
  const nav = useNavigate()
  const [qian, setqian] = useState(false)
  const [ming, setming] = useState(false)
  const [kedian, setkedian] = useState(false)
  const [type, settype] = useState(false)


  const [info, { data: infoData }] = useInfoMutation()
  const [times, { data: timesData2, isSuccess }] = useTimesMutation()
  const [update] = useUpdateMutation()


  const [wucan, setWucan] = useState(-1)
  const [wancan, setWancan] = useState(-1)
  const [taolunhui1, settaolunhui1] = useState(-1)
  const [taolunhui2, settaolunhui2] = useState(-1)
  const [gc, setGc] = useState(-1)
  const [gc2, setGc2] = useState(-1)
  const [xiaohui,setxiaohui] = useState(-1)
  const [beizhu,setbeizhu] = useState("0")


  const [timesData, settimesData] = useState([
    {
      "id":0,"name":1,"over":0
    },{"id":0,"name":2,"over":0
    },{"id":0,"name":3,"over":0}
  ])

  const [canjia, setCanjia] = useState('')

  const tijiao = () => {
    if (yiyue == false) {


      setqueren2(true)
      setTimeout(() => {
        setqueren2(false)
      }, 1500)
      return

    }
    if(type==2){
      if (wucan < 0 || wancan< 0 || taolunhui1 < 0|| taolunhui2  < 0 ) {

        console.log(wucan)
        console.log(wancan)
        console.log(taolunhui1)
        console.log(taolunhui2)
        console.log(gc)
        setqueren(true)
        setTimeout(() => {
          setqueren(false)
        }, 1500)
        return

      }
      update({
        "lan": t("is_en") == 1 ? "en" : "zh",
        "token": localStorage.getItem('li_token'),
        "f1": "",
        "f2": wucan,
        "f3": taolunhui1,
        "f4": taolunhui2,
        "f5":wancan,
        "user_id": localStorage.getItem('li_user_id')
      }).then(res => {
        console.log(res)

        if (res.data.rs === true) {
          setdone(true)
          setdone2(true)
          dispatch(changeXuan(3))
          nav('/home/application', { replace: true })

        } else {

        }

      });
    }else{
      // 隐藏工厂参观时 gc 恒为 -1，不能再当必填项校验，否则谁都提交不了
      if (wucan < 0 || wancan< 0 || taolunhui1 < 0|| taolunhui2  < 0 || (SHOW_FACTORY && gc<0)) {

        console.log(wucan)
        console.log(wancan)
        console.log(taolunhui1)
        console.log(taolunhui2)
        console.log(gc)
        setqueren(true)
        setTimeout(() => {
          setqueren(false)
        }, 1500)
        return

      }
      update({
        "lan": t("is_en") == 1 ? "en" : "zh",
        "token": localStorage.getItem('li_token'),
        "f1": SHOW_FACTORY ? gc : 0,
        "f2": wucan,
        "f3": taolunhui1,
        "f4": taolunhui2,
        "f5":wancan,
        "user_id": localStorage.getItem('li_user_id')
      }).then(res => {
        console.log(res)

        if (res.data.rs === true) {
          setdone(true)
          setdone2(true)
          dispatch(changeXuan(3))
          nav('/home/application', { replace: true })

        } else {

        }

      });
    }



  }

  const yiyueHandle = (e) => {


    console.log(kedian + "-----可点")
    if (kedian) {
      setyiyue(e.target.checked)
    } else {
      document.body.style.overflow = 'hidden';
      setyiyue(e.target.checked)
      setqueren3(true);
      // setTimeout(() => {
      //   setchayue(false)
      // }, 1500)

    }
  }

  const yiyueHandle2 = () => {
    document.body.style.overflow = 'hidden';
    setqueren3(true);
    // const gou = document.documentElement.querySelector('#gou');
    // console.log(gou)
    // gou.checked=false
    // console.log(gou.checked)
    setyiyue(true)

    // const div = document.documentElement.querySelector('.div');
    // if (t("is_en") == '1') {
    //   div.style.height = '3750px'
    // } else {
    //   div.style.height = '3400px'
    // };
    // document.documentElement.scrollTop = 0
  }

  const querenHandle = () => {
    setqueren3(false);
    document.body.style.overflow = 'visible';
    // setkedian(true);
    // const div = document.documentElement.querySelector('.div');
    // if (t("is_en") == '1') {
    //   div.style.height = '4200px'
    // } else {
    //   div.style.height='4060px'
    // };
    setkedian(true)
  }
  const selectTime = (date) => {

    if (date === 12) {
      times({
        date: 12
      }).then(res => {
        console.log(res)
        if (res.data) {
          settimesData(res.data)
          sethei2(true)

        } else {

        }

      });
      // sethei2(true)
      // console.log(timesData[0].over)

    } else {

      times({
        date: 13
      }).then(res => {
        console.log(res)
        if (res.data) {
          sethei2(true)
        } else {

        }

      });
    }

  }

  useEffect(() => {
    // i18n.changeLanguage('en');
    // localStorage.setItem('li_lan', 'en')

    // const div = document.documentElement.querySelector('.div');
    // div.style.height=0
    // setTimeout(() => {
    //
    //   if (t("is_en") == '1') {
    //     div.style.height = '4200px'
    //   } else {
    //     div.style.height='4060px'
    //   };
    // }, 1)
    const div = document.documentElement.querySelector('.div');
    div.style.height=0
    setTimeout(() => {
      div.style.height='auto'
    }, 1)

    dispatch(changeXuan(2))


    info({
      token: localStorage.getItem('li_token')
    }).then(res => {
      console.log(res)

      if (res.data.rs === 1) {


        settype(res.data.data.type)
        if (res.data.data.submited == 1) {
          setGc(res.data.data.f1)
          setWucan(res.data.data.f2)
          settaolunhui1(res.data.data.f3)
          settaolunhui2(res.data.data.f4)
          setWancan(res.data.data.f5)


          if(res.data.data.f1==0){
            setGc2(0)
            setbeizhu(0)


          }else if(res.data.data.f1==1){
            setGc2(1)
            setCanjia('8:30-11:00')
            setbeizhu(1)
          }else if(res.data.data.f1==2){
            setGc2(1)
            setCanjia('9:00-11:30')
            setbeizhu(2)
          }else if(res.data.data.f1==3){
            setGc2(1)
            setCanjia('9:30-12:00')
            setbeizhu(3)
          }
          setdone(true)
          setdone2(true)
        }
        if(res.data.data.type==2){
          setdone2(true)

        }

      } else if (res.data.rs === 0) {
        localStorage.removeItem('li_token')
        localStorage.removeItem('li_user_id')
        nav('/login', { replace: true })
      } else {

      }



    });
  }, [])




  const timeItem = () => {
    return (
      <>
        <div style={{
          width: '2000px',
          height: '2000px',
          position: 'fixed',
          top: '0px',
          backgroundColor: "#000",
          opacity: 0.4,
          left: 0,
          zIndex: 2
        }} onClick={() => { sethei(false) }}></div>
        <div className="information-view-3">
          <div className="information-overlap-10" >
            {
              timesData[0].over === 0 ? <div className="information-text-wrapper-19 text-wrapper-kong">{timesData[0].name}  {t("f_meet_fill")}</div> :
                <div className="information-text-wrapper-19 "
                  onClick={() => { setgccg12id(timesData[0].id); setgccg12(timesData[0].name); sethei(false); setgccg12gou(true); setgccg13gou(false); setgccg13(t("f_meet_join")) }}
                >{timesData[0].name}</div>
            }
            {
              timesData[1].over === 1 ? <div className="information-text-wrapper-20 text-wrapper-kong">{timesData[1].name}  {t("f_meet_fill")}</div> :
                <div className="information-text-wrapper-20"
                  onClick={() => { setgccg12id(timesData[1].id); setgccg12(timesData[1].name); sethei(false); setgccg12gou(true); setgccg13gou(false); setgccg13(t("f_meet_join")) }}
                >{timesData[1].name}</div>
            }
            {
              timesData[2].over === 1 ? <div className="information-text-wrapper-21 text-wrapper-kong">{timesData[2].name}  {t("f_meet_fill")}</div> :
                <div className="information-text-wrapper-21"
                  onClick={() => { setgccg12id(timesData[2].id); setgccg12(timesData[2].name); sethei(false); setgccg12gou(true); setgccg13gou(false); setgccg13(t("f_meet_join")) }}
                >{timesData[2].name}</div>
            }
            {
              timesData[3].over === 1 ? <div className="information-text-wrapper-22 text-wrapper-kong">{timesData[3].name}  {t("f_meet_fill")}</div> :
                <div className="information-text-wrapper-22"
                  onClick={() => { setgccg12id(timesData[3].id); setgccg12(timesData[3].name); sethei(false); setgccg12gou(true); setgccg13gou(false); setgccg13(t("f_meet_join")) }}
                >{timesData[3].name}</div>
            }
            {/* <Icon20Danxuan className="icon-danxuan" /> */}



          </div>
        </div>
      </>
    )
  }
  const timeItem2 = () => {
    return (
      <>


        <div style={{
          width: '2000px',
          height: '2000px',
          position: 'fixed',
          top: '0px',
          backgroundColor: "#000",
          opacity: 0.4,
          left: 0,
          zIndex: 2
        }} onClick={() => { sethei2(false) }}></div>
        <div className="information-view-3">
          <div className="information-overlap-10" >
            {/*{*/}
            {/*  timesData[0].over === 1 ? <div className="information-text-wrapper-19 text-wrapper-kong">{t("第一批次")}{timesData[0].name}  {t("f_meet_fill")}</div> :*/}
            {/*    <div className="information-text-wrapper-19 "*/}
            {/*      onClick={() => { sethei2(false); setCanjia(timesData[0].name);setGc(timesData[0].id);setGc2(1) }}*/}
            {/*    >{t("第一批次")}{timesData[0].name}</div>*/}
            {/*}*/}
            {/*{*/}
            {/*  timesData[1].over === 1 ? <div className="information-text-wrapper-20 text-wrapper-kong">{t("第一批次")}{timesData[1].name}  {t("f_meet_fill")}</div> :*/}
            {/*    <div className="information-text-wrapper-20"*/}
            {/*      onClick={() => { sethei2(false); setCanjia(timesData[1].name) ;setGc(timesData[1].id);setGc2(1)}}*/}
            {/*    >{t("第二批次")}{timesData[1].name}</div>*/}
            {/*}*/}
            {/*{*/}
            {/*  timesData[2].over === 1 ? <div className="information-text-wrapper-21 text-wrapper-kong">{t("第一批次")}{timesData[2].name}  {t("f_meet_fill")}</div> :*/}
            {/*    <div className="information-text-wrapper-21"*/}
            {/*      onClick={() => { sethei2(false); setCanjia(timesData[2].name) ;setGc(timesData[2].id);setGc2(1)}}*/}
            {/*    >{t("第三批次")}{timesData[2].name}</div>*/}
            {/*}*/}
            {
              timesData[0].over === 1 ? <div className="information-text-wrapper-19 text-wrapper-kong" style={{fontSize:'28px'}}>{timesData[0].name}（08:00-08:30中吴宾馆集合）{t("f_meet_fill")}</div> :
                  <div className="information-text-wrapper-19 " style={{fontSize:'28px'}}
                       onClick={() => { sethei2(false); setCanjia(timesData[0].name);setGc(timesData[0].id);setGc2(1);setbeizhu(1) }}
                  >{timesData[0].name}{t("备注11")}
                  </div>
            }
            {
              timesData[1].over === 1 ? <div className="information-text-wrapper-20 text-wrapper-kong" style={{fontSize:'28px'}}>{timesData[1].name}（08:30-09:00中吴宾馆集合）{t("f_meet_fill")}</div> :
                  <div className="information-text-wrapper-20" style={{fontSize:'28px'}}
                       onClick={() => { sethei2(false); setCanjia(timesData[1].name) ;setGc(timesData[1].id);setGc2(1);setbeizhu(2)}}
                  >{timesData[1].name}{t("备注22")}</div>
            }
            {
              timesData[2].over === 1 ? <div className="information-text-wrapper-21 text-wrapper-kong" style={{fontSize:'28px'}}>{timesData[2].name}（09:00-09:30中吴宾馆集合）{t("f_meet_fill")}</div> :
                  <div className="information-text-wrapper-21" style={{fontSize:'28px'}}
                       onClick={() => { sethei2(false); setCanjia(timesData[2].name) ;setGc(timesData[2].id);setGc2(1);setbeizhu(3)}}
                  >{timesData[2].name}{t("备注33")}</div>
            }


          </div>
        </div>
      </>
    )
  }
  return (
    <div className="information">
      <div className="div">
        {
          queren ?
              <div className="frame" style={t("is_en") == '1' ? {marginLeft:"40px",left:0,width:"700px"} : {}}>
                <div className="text-wrapper-frame">
                  {t("v_confirm_title1")}
                  <br/>
                  {t("v_confirm_title2")}
                </div>
              </div> : null
        }
        {
          queren2 ?
              <div className="frame2" style={t("is_en") == '1' ? {marginLeft:"40px",left:0,width:"700px"} : {}}>
                <div className="text-wrapper-frame">

                  {t("请同意")}

                </div>
              </div> : null
        }
        {
          baocuo ?
              <div className="frame2" style={t("is_en") == '1' ? {marginLeft:"40px",left:0,width:"700px"} : {}}>
                <div className="text-wrapper-frame">

                  {baocuo}

                </div>
              </div> : null
        }
        {
          chayue ?
              <div className="frame2" style={t("is_en") == '1' ? {marginLeft:"40px",left:0,width:"700px"} : {}}>
                <div className="text-wrapper-frame">

                  {t("请同意")}

                </div>
              </div> : null
        }
        {
          queren3 ?
              <div className="baomikuang">
                <div className="baomi">


                </div>
                <div style={{justifyContent:'center',display:'flex',position:'fixed',bottom:1600}}>
                  <div className="baomi-content" style={{overflow:'scroll',height:"1200px"}}>
                    <img src={t("is_en") == '1' ? "/img/2026-9/xieyi-en.png" : "/img/2026-9/xieyi.png"} alt=""
                         className="xieyi"/>
                    {
                      ming ? <div className="basetu">
                        <img src={`${ming}`} alt=""/>
                      </div> : null
                    }

                    {/* <div className="qianming" onClick={()=>{
                  setqian(true)
                }}> */}
                    {/* <div className="qianming-btn">
                点击签名
                </div> */}

                    {/* </div> */}

                    <div className="qingqueren">
                      <img src={t("is_en") == '1' ? "/img/tongyi_en.png" : "/img/tongyi.png"} alt=""
                           className="qingqueren-btn" onClick={querenHandle}
                           style={t("is_en") == '1' ? {marginTop: "75px"} : {}}/>
                    </div>

                  </div>

                </div>

              </div> : null
        }

        {/*{*/}
        {/*  hei ? timeItem() : null*/}
        {/*}*/}
        {
          SHOW_FACTORY && hei2 ? timeItem2() : null
        }
        {
          qian ? <Sign close={(e) => {
            setqian(false);
            setming(e);
          }}/> : null
        }
        <img src={t("is_en") == 1 ? "/img/logo-en.png" : "/img/login/logo.png"} alt="" className="logo"/>


        <div className="group-18">

          <img
              className="mask-group"
              alt="Mask group"
              src="/img/2026-9/bg3.png"
          />
          <div className="text-wrapper-16 zhong"
               style={t("is_en") == '1' ? {fontSize: "34px"} : {}}>{t("理想汽车2026全球合作伙伴大会")}</div>
          <div className="group-19">
            <div className="text-wrapper-17">{t("活动地点：常州中吴宾馆")}</div>
            <div className="overlap-group-wrapper-4">
              <div className="overlap-group-5">
              <div className="subtract-wrapper">
                  <img
                      style={{width: "30px", height: "30px"}}
                      alt="Subtract"
                      src="/img/2025/didian.png"
                  />
                </div>

              </div>
            </div>
          </div>

          <div className="group-20">
            <div className="text-wrapper-17" >      {t("地址：江苏省常州市钟楼区中吴大道1899号 常州中吴宾馆 2号门")}</div>
            <div className="overlap-group-wrapper-4">
              <div className="overlap-group-5">
                <img
                    style={{width: "30px", height: "30px"}}
                    alt="Subtract"
                    src="/img/2025/adddress.png"
                />
              </div>
            </div>
          </div>
          <div className='jianyi'>

            {t("着装建议：")}
            <br/>
            {t("商务休闲装，如您参加工厂参观，请勿穿着短裤和拖鞋。")}

          </div>
        </div>

        <div className="group-2">
          <div className="text-wrapper-2" style={t("is_en") == '1' ? {top: "-120px"} : {}}>{t("f_meet_title")}</div>
          <div className="text-wrapper-3">{t("10月22日 周四")}</div>
          <div className="group-6">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">{t("全天 | 09: 00-19: 00")}</div>
                <div className="group-7">

                  <div className="text-wrapper-6">{t("智链公园")}</div>
                  <div className="text-wrapper-11">{t("1F户外草坪")}</div>
                </div>

              </div>
            </div>
          </div>
          {SHOW_FACTORY ? (
          <div className="group-6">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">
                  {
                  beizhu==1? <div>
                    <div>{t("备注1")}</div>
                    <div>{t("备注11")}</div>
                  </div> : null
                }{
                  beizhu==2? <div>
                    <div>{t("备注2")}</div>
                    <div>{t("备注22")}</div>
                  </div> : null
                }{
                  beizhu==3? <div>
                    <div>{t("备注3")}</div>
                    <div>{t("备注33")}</div>
                  </div> : null
                }
                  {
                    beizhu==0? <div>
                      <div>-</div>

                    </div> : null
                  }
                  </div>

                <div className="group-7">

                  <div className="text-wrapper-6">{t("工厂参观")}</div>

                </div>
                <div className="group-3">
                  <div className="overlap-group-wrapper-3">
                    <button
                        className={gc2 === 1 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {

                          selectTime(12)
                        }} disabled={done2}
                    >
                      <div className="text-wrapper-9">{canjia} {t("f_meet_join")}</div>
                    </button>
                  </div>
                  <div className="overlap-group-wrapper-2">
                    <button
                        className={gc2 === 0 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          setGc2(0);setCanjia('');setGc(0);setbeizhu(0)
                        }} disabled={done2} id='gongchang'
                    >
                      <div className="text-wrapper-10">{t("f_meet_not_join")}</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : null}
          <div className="group-8">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">{t("中午 | 11: 00-12: 30")}</div>
                <div className="group-7">

                  <div className="text-wrapper-6">{t("自助午餐")}</div>
                  <div className="text-wrapper-11">{t("3F中吴宴会厅")}</div>
                </div>
                <div className="group-3">
                  <div className="overlap-group-wrapper-3">
                    <button
                        className={wucan === 1 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          setWucan(1)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-9">{t("f_meet_join")}</div>
                    </button>
                  </div>
                  <div className="overlap-group-wrapper-2">
                    <button
                        className={wucan === 0 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          setWucan(0)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-10">{t("f_meet_not_join")}</div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="group-6">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">{t("中午 | 12: 30-13: 00")}</div>
                <div className="group-7">

                  <div className="text-wrapper-6">{t("嘉宾入场")}</div>
                  <div className="text-wrapper-11">{t("中吴宾馆2号楼1F 大厅")}</div>
                </div>
                <div className="group-3">
                  <div className="overlap-group-wrapper-3">
                    <button
                        className={taolunhui1 === 1 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          settaolunhui1(1)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-9">{t("f_meet_join")}</div>
                    </button>
                  </div>
                  <div className="overlap-group-wrapper-2">
                    <button
                        className={taolunhui1 === 0 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          settaolunhui1(0)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-10">{t("f_meet_not_join")}</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="group-8">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">{t("下午 | 13: 00-17: 00")}</div>
                <div className="group-7">

                  <div className="text-wrapper-6">{t("合作伙伴会议暨颁奖典礼")}</div>
                  <div className="text-wrapper-11">{t("2F 龙城宴会厅")}</div>
                </div>
                <div className="group-3">
                  <div className="overlap-group-wrapper-3">
                    <button
                        className={taolunhui2 === 1 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          settaolunhui2(1)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-9">{t("f_meet_join")}</div>
                    </button>
                  </div>
                  <div className="overlap-group-wrapper-2">
                    <button
                        className={taolunhui2 === 0 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          settaolunhui2(0)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-10">{t("f_meet_not_join")}</div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="group-8">
            <div className="overlap-wrapper">
              <div className="overlap">

                <div className="text-wrapper-8">{t("晚上 | 18: 30-21: 20")}</div>
                <div className="group-7">

                  <div className="text-wrapper-6">{t("答谢晚宴")}</div>
                  <div className="text-wrapper-11">{t("3F 中吴宴会厅")}</div>
                </div>
                <div className="group-3">
                  <div className="overlap-group-wrapper-3">
                    <button
                        className={wancan === 1 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          setWancan(1)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-9">{t("f_meet_join")}</div>
                    </button>
                  </div>
                  <div className="overlap-group-wrapper-2">
                    <button
                        className={wancan === 0 ? "overlap-group-2 xuanzhong" : "overlap-group-2 weixuan"}
                        onClick={() => {
                          setWancan(0)
                        }} disabled={done}
                    >
                      <div className="text-wrapper-10">{t("f_meet_not_join")}</div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>


        {/*    <div className="text-wrapper-20">（报名截止日期：8月31日）</div>
       */}
        <div className="view-3">
          {
            done ? null : <div>
              <div>


                {/* <div style={t("is_en") == '1' ? { margin: '0 10px', width: '80%' } : {}} >
                  <label htmlFor="gou"> {t("同意")}</label>{t("is_en") == '1' ? <br></br> : null}
                  <span style={{ textDecoration: 'underline' }} onClick={yiyueHandle2}>{t("同意2")}</span>
                </div> */}

                {
                  t("is_en") == '1' ?
                      <div style={{
                        textAlign: 'center',
                        fontSize: '28px',
                        marginBottom: '100px',
                        display: 'flex',
                        justifyContent: 'center',
                        color: '#808080',
                        position:'relative'
                      }}>
                        <input type="checkbox"
                               style={{width: '40px', height: '20px', position: 'absolute', top: '12px', left: '50px'}}
                               checked={yiyue} onChange={yiyueHandle} id="gou"/>
                        <div >
                          <div style={{fontWeight: '300'}}>
                            <label htmlFor="gou"> {t("同意")}</label>
                          </div>

                          <div style={{textAlign: 'center'}}>
                            {/* <img src="/img/agree.png" alt="" style={{ width: '560px' }} onClick={yiyueHandle2}/> */}
                            <div style={{textDecoration: 'underline'}} onClick={yiyueHandle2}>{t("理想汽车保密协议")}</div>

                          </div>
                        </div>


                      </div>
                      :
                      <div style={{
                        textAlign: 'center',
                        fontSize: '28px',
                        marginBottom: '100px',
                        display: 'flex',
                        justifyContent: 'center',
                        color:'#808080'
                      }}>

                        <input type="checkbox" style={t("is_en") == '1' ? {width: '40px', height: '20px'} : {
                          width: '40px',
                          height: '20px',
                          marginTop: '10px'
                        }} checked={yiyue} onChange={yiyueHandle} id="gou"/>
                        <div>
                          <label htmlFor="gou"> {t("同意")}</label>
                          <span style={{textDecoration: 'underline'}} onClick={yiyueHandle2}>{t("《理想汽车保密协议》")}</span>
                        </div>


                      </div>
                }


              </div>
              <div>
                <button className="overlap-9" onClick={tijiao}>
                  <div className="text-wrapper-21"> {t("f_meet_submit")}</div>
                </button>
              </div>

            </div>


          }

        </div>
      </div>
    </div>
  );
};
export default Information